<template lang="pug">
v-container(class='pa-0' fluid)
  v-layout
    v-flex(xs7)
      s-date-picker(
        v-model='datetime.date'
        :validator='validator'
        :label='label'
        :name='name'
      )
    v-flex(xs5)
      v-menu(
        :close-on-content-click='false'
        :return-value.sync='datetime.time'
        v-model='menu'
        ref='time'
        full-width
        min-width='290px'
        lazy
      )
        v-text-field(
          slot='activator'
          v-model='datetime.time'
          prepend-icon='access_time'
          clearable
          readonly
        )
        v-time-picker(
          @change='$refs.time.save(datetime.time)'
          v-model='datetime.time'
          format='24hr'
          full-width
        )
</template>

<script>
import dayjs from 'dayjs'
export default {
  props: {
    value: {
      type: String
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: 'Дата начала'
    },
    validator: {
      type: Object,
      required: false
    },
    today: {
      type: Boolean,
      default: true
    }
  },

  data: () => ({
    menu: false,
    datetime: {
      date: null,
      time: null
    }
  }),

  created() {
    this.setDate()
  },

  methods: {
    setDate() {
      if (this.value || this.today) {
        this.datetime.date = dayjs(this.value).format('YYYY-MM-DD')
        this.datetime.time = dayjs(this.value).format('HH:mm')
      }
    },

    refresh() {
      const date = (this.datetime.date || '')
      const time = (this.datetime.time || '')
      this.$emit('input', `${date} ${time}:00`)
    }
  },

  watch: {
    datetime: {
      deep: true,
      handler: 'refresh'
    },

    value() {
      this.setDate()
    }
  }
}
</script>
